import React, {Suspense} from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';

import { withAuthentication } from '../../components/Session';
import * as ROUTES from '../../constants/routes';
import {Helmet} from "react-helmet"
import { IklanProvider } from '../../features/Iklan';
//import LandingPage from '../Landing';
const LandingPage = React.lazy(()=> import('../Landing'))
//import SignUpPage from '../SignUp';
const SignUpPage = React.lazy(()=> import('../SignUp'))
//import SignInPage from '../SignIn';
const SignInPage = React.lazy(()=> import('../SignIn'))
//import PasswordForgetPage from '../PasswordForget';
const PasswordForgetPage = React.lazy(()=> import('../PasswordForget'))
//import HomePage from '../Home';
const HomePage = React.lazy(()=> import('../Home'))
//import AccountPage from '../Account';
const AccountPage = React.lazy(()=> import('../Account'))
//import AdminPage from '../Admin';
const AdminPage = React.lazy(()=> import('../Admin'))

//import NotFound from '../NotFound';
const NotFound = React.lazy(()=> import('../NotFound'))
//import Terms from '../Landing/Terms.js';
const Terms = React.lazy(()=> import('../Landing/Terms.js'))
//import Privacy from '../Landing/Privacy.js';
const Privacy = React.lazy(()=> import('../Landing/Privacy.js'))

//import AppointmentPage from '../Appointment';
const AppointmentPage = React.lazy(()=> import('../Appointment'))
const AppointmentDisplayPage = React.lazy(()=> import('../Appointment/Board'))

const StatusPage = React.lazy(()=> import('../Status'))
const OrdersPage = React.lazy(()=> import('../Orders'))
const VouchersPage = React.lazy(()=> import('../Vouchers/viewer'))
const AntrianPage = React.lazy(()=> import('../Antrian'))
const DisplayAntrianPage = React.lazy(()=> import('../Antrian/Display'))
const BlasterPage = React.lazy(()=> import('../Blast'))
const ToolWhatsappLinkPage = React.lazy(()=> import('../Tool/WhatsappLink'))
const ToolRoboContactPage = React.lazy(()=> import('../Tool/RoboContact'))
const ToolCariIklanPage = React.lazy(()=> import('../Tool/CariIklan'))
const PromoPage = React.lazy(()=> import('../Promo'))


//import DisplayPage from '../Display';
const DisplayPage = React.lazy(()=> import('../Display'))
//import SAPage from '../SA';
//const SAPage = React.lazy(()=> import('../SA'))
//const HistoryPage = React.lazy(()=> import('../History'))
//import MapPage from '../Map';
//const MapPage = React.lazy(()=> import('../Map'))
//import BoardPage from '../Board';
//const BoardPage = React.lazy(()=> import('../Board'))
//import InputJPCBPage from '../InputJPCB';
//const InputJPCBPage = React.lazy(()=> import('../InputJPCB'))

const GamesPage = React.lazy(()=> import('../Games'))
//import RecoveryPage from '../Recovery';
//const RecoveryPage = React.lazy(()=> import('../Recovery'))
/*
<Route path={ROUTES.SA} component={SAPage} />
        <Route path={ROUTES.MAP} component={MapPage} />
        <Route path={ROUTES.BOARD} component={BoardPage} />
        <Route path={ROUTES.INPUTJPCB} component={InputJPCBPage} />
        <Route path={ROUTES.RECOVERY} component={RecoveryPage} />

*/



const App = () => (
  <>
    <IklanProvider>
      <Helmet>
        <title>e-jpcb</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Bengkel Nissan Surabaya"
        />
        <meta property="og:description" content="Layanan 7x24 Jam"/>
        <meta property="og:url" content="https://e-jpcb.web.app"/>
        <meta property="og:image" content="https://e-jpcb.web.app/static/AYani.jpg"/>
      </Helmet>
      <Router>
        <Suspense fallback={<div>Just a moment...</div>} >
        <Switch>
          <Route exact path={ROUTES.LANDING} component={LandingPage} />
          <Route path={ROUTES.SIGN_UP} component={SignUpPage} />
          <Route path={ROUTES.SIGN_IN} component={SignInPage} />
          <Route path={ROUTES.PASSWORD_FORGET} component={PasswordForgetPage} />
          <Route path={ROUTES.HOME} component={HomePage} />
          <Route path={ROUTES.ACCOUNT} component={AccountPage} />
          <Route path={ROUTES.ADMIN} component={AdminPage} />
          <Route path={ROUTES.TERMS} component={Terms} />
          <Route path={ROUTES.PRIVACY} component={Privacy} />

        
          <Route path={ROUTES.APPOINTMENT} component={AppointmentPage} />
          <Route path={ROUTES.APPOINTMENT_DISPLAY} component={AppointmentDisplayPage} />
          <Route path={ROUTES.DISPLAY} component={DisplayPage} />
          <Route path={ROUTES.STATUS} component={StatusPage} />
          <Route path={ROUTES.ORDERS} component={OrdersPage} />
          <Route path={ROUTES.VOUCHERS} component={VouchersPage} />

          <Route path={ROUTES.ANTRIAN} component={AntrianPage} />
          <Route path={ROUTES.DISPLAY_ANTRIAN} component={DisplayAntrianPage} />
          <Route path={ROUTES.BLAST} component={BlasterPage} />
          <Route path={ROUTES.TOOL_WHATSAPP_LINK} component={ToolWhatsappLinkPage} />
          <Route path={ROUTES.TOOL_ROBO_CONTACT} component={ToolRoboContactPage} />
          <Route path={ROUTES.TOOL_CARI_IKLAN} component={ToolCariIklanPage} />
          
          <Route path={ROUTES.PROMO} component={PromoPage} />
          
          <Route path={ROUTES.GAMES} component={GamesPage} />
          

          <Route path={"*"} component={NotFound} />
        </Switch>
        </Suspense>
      </Router>
    </IklanProvider>
  </>
);
export default withAuthentication(App);